import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as AddImage } from 'assets/svg/icon-add-image.svg'

function IconAddImage(props: IconProps): JSX.Element {
  const title = 'icon-add-image'
  const { className, id = title, name = title, ...others } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} {...others}>
      <AddImage {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconAddImage
